import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { getFotoPerfilUrl } from "@/services/config";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";


// Toastification
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

// Máscara
import VueTheMask from "vue-the-mask";

router.beforeEach((to, from, next) => {
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (
    (to.path === "/admin/entrar" || to.path === "/admin/entrar-acesso") &&
    user
  ) {
    next({ path: "/admin/despedidas" });
  } else if (
    to.path.startsWith("/admin/") &&
    to.path != "/admin/entrar" &&
    to.path != "/admin/entrar-acesso" &&
    !user
  ) {
    next({ path: "/admin/entrar" });
  } else {
    next();
  }
});

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);
app.config.globalProperties.getFotoPerfilUrl = getFotoPerfilUrl;

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
};

app.use(VueTheMask);

app.use(vuetify).use(store).use(router).use(Toast, toastOptions).mount("#app");
